export default "__VITE_ASSET__BMmQTTBB__"